import { lazy } from 'preact/compat'

const CartVTEX = lazy(() => import('./vtex/Cart.tsx'))

export interface Props {
    freeShippingValue: number
    checkoutUrl: string
    couponMessages?: string
    useNewMinicartLayout?: boolean
    disableTrinioCheckout?: boolean
}

function Cart({
    freeShippingValue,
    checkoutUrl,
    couponMessages,
    useNewMinicartLayout,
    disableTrinioCheckout,
}: Props) {
    return (
        <CartVTEX
            freeShippingValue={freeShippingValue}
            checkoutUrl={checkoutUrl}
            couponMessages={couponMessages}
            useNewMinicartLayout={useNewMinicartLayout}
            disableTrinioCheckout={disableTrinioCheckout}
        />
    )
}

export default Cart
